import React from 'react';

import { TextField as MuiTextField } from '@material-ui/core';

const TextField = ({ ...props }) =>  <MuiTextField {...props}/>

export default TextField;



// WEBPACK FOOTER //
// ./src/components/base/TextField/TextField.js